import { Button, InlineNotification } from '@carbon/react';
import { ErrorFilled } from '@carbon/react/icons';
import type { ContentHeaderProps } from './types';
import styles from './content-header.module.scss';

/**
 * Content panel header bar with section title, optional unsaved changes indicator,
 * optional overlap error, and optional save button with its blocked reason.
 * When onSave is omitted, only the title (and overlap error) are rendered.
 * @param {ContentHeaderProps} props - The component props
 * @return {JSX.Element} The content header bar
 */
export function ContentHeader({
  title,
  isDirty,
  canSave,
  isSaving,
  onSave,
  saveLabel = 'Save Scenario',
  overlapError,
  saveBlockedReason,
}: ContentHeaderProps): JSX.Element {
  return (
    <div className={styles.contentHeader}>
      <div className={styles.titleRow}>
        <h4 className={styles.title}>{title}</h4>
        {overlapError && (
          <span className={styles.overlapError}>
            <ErrorFilled className={styles.overlapErrorIcon} />
            {overlapError}
          </span>
        )}
      </div>
      {onSave && (
        <div className={styles.actions}>
          {isDirty && (
            <InlineNotification
              kind="info"
              title="Unsaved changes"
              lowContrast
              hideCloseButton
            />
          )}
          {saveBlockedReason && (
            <span className={styles.overlapError}>
              <ErrorFilled className={styles.overlapErrorIcon} />
              {saveBlockedReason}
            </span>
          )}
          <Button
            kind="primary"
            size="md"
            disabled={!canSave || isSaving}
            onClick={onSave}
          >
            {isSaving ? 'Saving...' : saveLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
